type Props = {
  icon?: string;
  title: string;
  description?: string;
};

export default function EmptyState({ icon = "ri-inbox-line", title, description }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-16 md:py-24 text-center">
      <span className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-background-100 border border-background-200 text-secondary-600">
        <i className={`${icon} text-3xl md:text-4xl`} />
      </span>
      <p className="mt-5 font-heading text-lg text-foreground-900">{title}</p>
      {description && <p className="mt-2 text-sm text-secondary-500 max-w-sm">{description}</p>}
    </div>
  );
}